import { LabelMedium, ParagraphMedium, ParagraphXSmall } from "baseui/typography"
import { HttpStatusCodesToString } from "../../services/types"

export type HttpErrorMsgProps = {
    message: any,
    httpstatus: any
}

const HttpErrorMsg = ({  message, httpstatus }: HttpErrorMsgProps) => {
    return (
        <>
            <LabelMedium color='white' marginBottom={'20px'} >{HttpStatusCodesToString(httpstatus)}</LabelMedium>
            <ParagraphMedium color='white' margin={0} >{message}</ParagraphMedium>
        </>
    )
}

export default HttpErrorMsg;
